import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { apiPath } from '../../constants/api-routes';
import { ApiResponse } from '../../models';
interface ActiveCallData {
  type: string;
  active_call_count: number;
  timestamp: string;
}

interface ConnectionRateData {
  date: string;
  percentage: number;
}

interface GraphData {
  date: string;
  count: number;
}

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private activeCallsSocket$: WebSocketSubject<ActiveCallData> | null = null;

  constructor(private http: HttpClient) {}

  getCallCounts(time: string, payload: any) {
    return this.http.post<
      ApiResponse<{
        totalCalls: number;
        outgoingCalls: number;
        inProgressCalls: number;
      }>
    >(`${apiPath.dashboard.fetchCardData}/${time}`, payload, {
      withCredentials: true,
    });
  }

  getOutboundCalls(time: string, payload: any) {
    return this.http.post<ApiResponse<GraphData[]>>(
      `${apiPath.dashboard.fetchOutgoingChartData}/${time}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  getConnectionRate(time: string, payload: any) {
    return this.http.post<ApiResponse<ConnectionRateData[]>>(
      `${apiPath.dashboard.fetchConnectionRateChartData}/${time}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  getConcurrentCalls(time: string = '30', payload: any) {
    return this.http.post<ApiResponse<GraphData[]>>(
      `${apiPath.dashboard.fetchConcurrentCallsChartData}/${time}`,
      payload
    );
  }

  // getSuccessRate(
  //   time: string = '30'
  // ): Observable<DashboardSuccessRateResponse> {
  //   return this.http.get<DashboardSuccessRateResponse>(
  //     `${this.baseUrl}Dashboard/successrate/${time}`
  //   );
  // }
  getActiveCallsStream(): WebSocketSubject<ActiveCallData> {
    if (!this.activeCallsSocket$) {
      this.activeCallsSocket$ = webSocket<ActiveCallData>({
        url: apiPath.dashboard.trackActiveCalls,
        closeObserver: {
          next: () => {
            console.log('WebSocket connection closed for active calls');
          },
        },
      });
    }
    return this.activeCallsSocket$;
  }

  closeActiveCallsStream(): void {
    if (this.activeCallsSocket$) {
      this.activeCallsSocket$.complete();
      this.activeCallsSocket$ = null;
    }
  }
}
